// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import 'bootstrap/dist/css/bootstrap.min.css';

import theme from './theme';
import { AuthProvider } from './AuthContext';

import Login from './components/Login';
import PrivateRoute from './components/PrivateRoute';
import DashboardLayout from './components/DashboardLayout';
import Clientes from './components/Clientes';
import Vehiculos from './components/Vehiculos';
import Ordenes from './components/OrdenesDashboard';
import NuevaOrden from './components/ordenes/NuevaOrden';
import IngresosGastos from './components/IngresosGastos';
import OrdenDetalle from './components/ordenes/OrdenDetalle';
import ReparacionesOrden from './components/ordenes/ReparacionesOdenes';
import Facturas from './components/FacturacionOrden';
import Historial from './components/Historial';
import Inventario from './components/InventarioDashboard';
import Tecnicos from './components/Tecnicos';
import Presupuestos from './components/Presupuestos';
import AgendarCita from './components/citas/AgendarCita';
import CancelarCita from './components/citas/CancelarCita';
import CitasDashboard from './components/citas/CitasDashboard';
import './components/main.css';

function MainApp() {
  return (
    <Router>
      <Routes>
        {/* Público: agendamiento y cancelación de citas, sin login */}
        <Route path="/" element={<AgendarCita />} />
        <Route path="/citas/cancelar/:token" element={<CancelarCita />} />
        <Route path="/login" element={<Login />} />

        {/* Panel interno del taller: requiere login */}
        <Route element={<PrivateRoute />}>
          <Route element={<DashboardLayout />}>
            <Route path="/clientes" element={<Clientes />} />
            <Route path="/vehiculos" element={<Vehiculos />} />
            <Route path="/ordenes" element={<Ordenes />} />
            <Route path="/facturas" element={<Facturas />} />
            <Route path="/ordenes/nueva" element={<NuevaOrden />} />
            <Route path="/ordenes/:id" element={<OrdenDetalle />} />
            <Route path="/ingresos-gastos" element={<IngresosGastos />} />
            <Route path="/ordenes/:id/reparaciones" element={<ReparacionesOrden />} />
            <Route path="/historial" element={<Historial />} />
            <Route path="/inventario" element={<Inventario />} />
            <Route path="/tecnicos" element={<Tecnicos />} />
            <Route path="/presupuestos" element={<Presupuestos />} />
            <Route path="/citas" element={<CitasDashboard />} />
            <Route path="*" element={<IngresosGastos />} />
          </Route>
        </Route>
      </Routes>
    </Router>
  );
}

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <MainApp />
      </AuthProvider>
    </ThemeProvider>
  );
}
